import * as React from 'react';

import { CourseraMetatags } from 'bundles/seo';

import _t from 'i18n!nls/career-academy';

export const ConsumerPathwayCareerAcademyPageSEO = () => {
  const title = _t('Explore Career Paths: Find Courses and Build Skills by Job Role');

  return (
    <CourseraMetatags
      metaNameAndProperties={{
        title,
        description: _t(
          'Explore career paths and find the right courses to build essential skills. Explore job roles and access resources to start or advance your career.'
        ),
        ogAndTwitterTitle: title,
        disableCourseraDescriptionSuffix: true,
        enableCrawlerIndexing: true,
      }}
    />
  );
};

export default ConsumerPathwayCareerAcademyPageSEO;
